import {
  IAppService,
  IServiceEndPoints,
  IRouteInfo,
  IPartnerBundle,
  ISharedComponents,
  ISharedComponentConfig,
  ComponentFramework
} from '@fxp/fxpservices';
import { appSettings } from './environments/common/appsettingsGenerator';
import { PartnerAppRegistrationService } from '@fxp/fxpservices';

export class SampleApplication_routes implements IAppService {
  getRoutes(): IRouteInfo {
    const routeInfo: IRouteInfo = {
      applicationName: 'psdl',
      sharedBundles: [],
      routes: []
    };

    return routeInfo;
  }

  getServiceEndPoints(): Array<IServiceEndPoints> {
    return appSettings().serviceEndPoints;
  }

  getBundles(): IPartnerBundle[] {
    const baseUrl = appSettings().cdnBaseUrl;
    const bundle: IPartnerBundle = {
      name: 'DM-React-BundleTest',
      files: [`${baseUrl}/vendor.bundle.js`, `${baseUrl}/styles.bundle.js`, `${baseUrl}/main.bundle.js`],
      sequentialLoading: true
    };

    return [bundle];
  }

  getSharedComponentsInfo(): ISharedComponents {

    const myComponentSharedComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e08-MyComponent-Bundle',
      componentName: 'psdl.successprogram',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const sharedComponentsInProject: ISharedComponents = {
      appName: 'psdl.successprogram', // Name of the application. Use the same name what you have used in main.ts file with registerPartnerApp method.
      components: [
        myComponentSharedComponent
      ],
      // List of ISharedComponentConfig. Add all the ISharedComponentConfig objects here.
      disableSharing: false, // Turing it off will disable the sharing and your partners will not be able to consume the components.
      sharedBundles: []
    };
    return sharedComponentsInProject;
  }
  public getGeneratedBundles() {
    var baseUrl = '';
    var currentScriptUrl = document.currentScript['src'];
    if (currentScriptUrl.indexOf('exclude.inline.bundle') > 0) {
      currentScriptUrl = Error().stack.match(/(https?:\/\/[^ ]*)/g);
      baseUrl = currentScriptUrl
        .filter((item) => item.indexOf('localhost:5000') === -1)[0]
        .toLowerCase();
      baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
    } else {
      baseUrl = currentScriptUrl.substring(0, currentScriptUrl.lastIndexOf('/'));
    }
    if (baseUrl.endsWith("/")){
        baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
    }
    // Support Delivery specific: If the URL has build parameter, then load the bundles from the build folder
    var sdBuildId = new URLSearchParams(window.location.hash.split("?").pop()).get("build");
    if (sdBuildId) {
        baseUrl = baseUrl.replace("/react", "/build") + "/" + sdBuildId + "/react";
    }
    return [
            {
                name: '02c7b1c92e08-MyComponent-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/MyComponent.vendor.bundle.js',
                    baseUrl + '/MyComponent.bundle.js'
                ],
                sequentialLoading: true
            },

    ]
}
}

PartnerAppRegistrationService.registerLazyLoadedApp(SampleApplication_routes, 'psdl');
